<template>
  <!-- Layout for the sign-in pages (US 9383): product panel on the left, the page's form on the right -->
  <div class="lg-page">
    <aside class="lg-side">
      <a href="https://www.complyon.com/" class="lg-side__logo">
        <img src="@/assets/complyon-light-logo-text.svg" alt="Complyon">
      </a>
      <h2 class="lg-side__title">
        {{ $t('login.hero_title_1') }}<br>
        <em>{{ $t('login.hero_title_2') }}</em>
      </h2>
      <p class="lg-side__text">{{ $t('login.hero_text') }}</p>

      <!-- Decoration only: framework names are proper nouns and not translated -->
      <div class="lg-orbit" aria-hidden="true">
        <div class="lg-orbit__ring lg-orbit__ring--outer"></div>
        <div class="lg-orbit__ring lg-orbit__ring--middle"></div>
        <div class="lg-orbit__ring lg-orbit__ring--inner"></div>
        <div class="lg-orbit__core"><font-awesome-icon icon="shield-alt"/></div>
        <span v-for="framework in frameworks"
              :key="framework.name"
              class="lg-orbit__chip"
              :style="{ left: framework.x + 'px', top: framework.y + 'px' }"
        ><i :style="{ background: framework.color }"></i>{{ framework.name }}</span>
      </div>
    </aside>

    <main class="lg-main">
      <div class="lg-main__bar">
        <b-dropdown right variant="link" toggle-class="lg-lang" no-caret qid="login-language-select">
          <template #button-content>
            <font-awesome-icon icon="globe"/>
            <span>{{ currentLanguage.title }}</span>
            <font-awesome-icon icon="chevron-down" class="lg-lang__chevron"/>
          </template>
          <b-dropdown-header>{{ $t('login.language_label') }}</b-dropdown-header>
          <b-dropdown-item v-for="language in languages"
                           :key="language.value"
                           :active="language.value === currentLanguage.value"
                           :lang="language.value"
                           @click="selectLanguage(language.value)"
                           :qid="'login-language-' + language.value"
          >{{ language.title }}</b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="lg-box" :class="{ 'lg-box--wide': wide }">
        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script>
import '@fontsource-variable/fraunces';
import '@fontsource-variable/fraunces/wght-italic.css';
import moment from 'moment';
import piincHttp from '@/util/configureAxios.js'

export default {
  name: 'AuthLayout',
  props: {
    // Wider form column, for pages with more fields (register)
    wide: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      // Each language in its own name; these are never translated
      languages: [
        { value: 'da', title: 'Dansk' },
        { value: 'de', title: 'Deutsch' },
        { value: 'en', title: 'English' },
        { value: 'fr', title: 'Français' },
      ],
      frameworks: [
        { name: 'NIS2', color: '#FFC96B', x: 250, y: 8 },
        { name: 'ISO 27001', color: '#8FB4FF', x: 90, y: 60 },
        { name: 'GDPR', color: '#7FE0C4', x: 40, y: 230 },
        { name: 'AI Act', color: '#7FE0C4', x: 20, y: 300 },
        { name: 'DORA', color: '#C9B6FF', x: 330, y: 440 },
        { name: 'ISAE 3402', color: '#FF9E9E', x: 200, y: 500 },
      ],
    }
  },
  computed: {
    currentLanguage() {
      return this.languages.find(language => language.value === this.$i18n.locale) || this.languages[2];
    }
  },
  methods: {
    selectLanguage(language) {
      localStorage.setItem('lang', language);
      this.$i18n.locale = language;
      this.$i18n.fallbackLocale = language;
      moment.locale(language);
      piincHttp.defaults.headers['Language'] = language;
      document.documentElement.setAttribute('lang', language);
    }
  }
}
</script>
